export interface InstructionalVideoDto {
    idInstructionalVideo: number
    sequenceNo: number
    title: string
    description?: string
    url: string
    watchState?: WatchState
    idAdministration: number
}

export enum WatchState {
    Not = 0,
    Partially = 1,
    Fully = 2,
}
